import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from './reducers';

const SetTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState, key) => {
    // convert mySet to an Array.
    return inboundState;
  },
  // transform state being rehydrated
  (outboundState, key) => {
    // convert mySet back to a Set.
  },
  // define which reducers this transform gets called for.
  { whitelist: [] }
);
const persistConfig = {
  key: 'root',
  storage,
  transforms: [SetTransform],
  whitelist: ['auth', 'kpi'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const initialState = {};
const middleware = [thunk];
const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
export default () => {
  let store = createStore(persistedReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));
  let persistor = persistStore(store);
  return { store, persistor };
};
